interface IPatters {
  uppercase_letters: RegExp
  lowercase_letters: RegExp
  only_numbers: RegExp
  only_letters: RegExp
  spaces: RegExp
  repeat_characters: RegExp
  subcontract: RegExp
  outsourcing: RegExp
}

const PATTERNS = Object.freeze<IPatters>({
  uppercase_letters: /[A-Z]/g,
  lowercase_letters: /[a-z]/g,
  only_letters: /[A-Za-z]/g,
  only_numbers: /[0-9]/g,
  spaces: /\s/g,
  repeat_characters: /(\w+)\W*(\1\W*){2,}/g,
  subcontract: /[0-9a-zA-Z]+SC[0-9]+$/gi,
  outsourcing: /[0-9a-zA-Z]+SC[0-9]+Q[0-9]+$/gi
})

export default PATTERNS
